module.exports = __webpack_public_path__ + "img/logo_corresponsables.b3baf1db.webp";